import cars from "../data/cars";
import CarCard from "./CarCard";

function FeaturedCars() {

  return (
    <section className="featured">

      <h2 data-aos="fade-up">
        Featured Cars
      </h2>

      <div className="grid">

        {cars.slice(0, 6).map((car) => (
          <CarCard key={car.id} car={car} />
        ))}

      </div>

    </section>
  );
}

export default FeaturedCars;